export const handleParamChange = (paramName, value) => {
    const qs = new URLSearchParams();
    if (!value || (Array.isArray(value) && value.length === 0)) {
        return qs;
    }
    if (Array.isArray(value)) {
        qs.append(paramName, value.join(','));
    }
    else {
        qs.append(paramName, value.toString());
    }
    return qs;
};
